/**
 * This hook is used to get the nextJs router optional so it can be used in the server-rendering context like email rendering.
 */

import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';
import { NextRouter } from 'next/router';
import { useContext } from 'react';

const FAKE_ROUTER = {
  asPath: '',
  pathname: '',
  events: {
    off: () => 0,
    on: () => 0,
    emit: () => 0,
  },
  push: () => {
    throw 'Push: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  route: '',
  query: {},
  basePath: '',
  isLocaleDomain: false,
  replace: () => {
    throw 'Replace: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  forward: () => {
    throw 'Forward: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  back: () => {
    throw 'Back: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  reload: () => {
    throw 'Reload: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  prefetch: () => {
    throw 'Prefetch: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  beforePopState: () => {
    throw 'BeforePopState: FakeRouter cannot be used in client-rendering context! Please check your implementation.';
  },
  isFallback: false,
  isReady: false,
  isPreview: false,
};

export function useOptionalRouter(): NextRouter {
  const router = useContext(RouterContext);
  if (!router) {
    return FAKE_ROUTER;
  }
  return router;
}
